module.exports = __webpack_public_path__ + "img/person-in-lotus-position.15dd8d67.png";